import { ethers, Eip1193Provider, TransactionReceipt } from 'ethers';

const getProvider = () => {
  if (window.ethereum) {
    return new ethers.BrowserProvider(window.ethereum as unknown as Eip1193Provider);
  } else {
    console.warn('No Ethereum provider found. Please install a wallet like MetaMask.');
    return null;
  }
};

const getSigner = async () => {
  const provider = getProvider();
  if (provider) {
    return await provider.getSigner();
  } else {
    return null;
  }
};

const connectWallet = async () => {
  const provider = getProvider();
  if (provider) {
    try {
      await provider.send('eth_requestAccounts', []);
      return await getSigner();
    } catch {
      console.error('User denied account access');
      return null;
    }
  } else {
    return null;
  }
};

const sendTransaction = async (to: string, value: string): Promise<TransactionReceipt | null> => {
  const signer = await getSigner();
  if (signer) {
    try {
      const tx = await signer.sendTransaction({
        to: to,
        value: ethers.parseEther(value),
      });
      const receipt = await tx.wait();
      return receipt;
    } catch (error) {
      console.error('Transaction failed:', error);
      return null;
    }
  } else {
    return null;
  }
};

const blockchainService = {
  connectWallet,
  getSigner,
  sendTransaction,
};

export default blockchainService;
